import axios from 'axios';
import { INVITE_REQUEST,INVITE_USER,INVITE_ERROR} from './types'

var basedev = "https://api.cheerbox.com/api/"
export const inviteUser = (data) =>dispatch=> {

    var endpoint = basedev +'invite'
    var headers = {
        'Authorization':"Bearer " + localStorage.getItem('access_token')

    } 
        dispatch({
            type:INVITE_REQUEST
        })
      axios.post(endpoint,data, {headers: headers})
        .then(res => {

            dispatch({
                type:INVITE_USER,
                payload: res.data
            })
        }).catch(error=>{
            dispatch({
                type:INVITE_ERROR,
                payload:null
            })
        })
        
        


    /* return dispatch => {
        // Utils.login(email, password)
        //     .then(user => {
        //         dispatch(login());
        //     })
        //     .catch(error => {

        //     });
        setTimeout(()=>{
            dispatch(login());
        }, 4000);
    }  */
}
